/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Col as AntDCol, ColProps as AntDColProps } from 'antd';

export type ColProps = {
  children?: React.ReactNode;
  flex?: AntDColProps['flex'];
  span?: number | string;
  offset?: number | string;
  xs?: AntDColProps['xs'];
  sm?: AntDColProps['sm'];
  md?: AntDColProps['md'];
  lg?: AntDColProps['lg'];
  xl?: AntDColProps['xl'];
  xxl?: AntDColProps['xxl'];
  style?: React.CSSProperties;
};

export function Col({ children, flex, span, offset, xs, sm, md, lg, xl, xxl, style }: ColProps) {
  return (
    <AntDCol flex={flex} span={span} offset={offset} xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl} style={style}>
      {children}
    </AntDCol>
  );
}
